import React from 'react';
import { Box } from '@mui/material';
import styled from '@emotion/styled';

const Container = styled(Box)`
  // max-width: 1200px;  /* Adjust as needed */
  margin: 0 auto;
  padding: 15px;
  background-color: #fff;  /* Adjust as needed */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);  /* Optional, for some elevation */
  border-radius: 8px;  /* Optional, for rounded corners */
`;

const PageContainer = ({ children }) => {
    return <Container>{children}</Container>;
};

export default PageContainer;
